import { Renta } from "src/gql/schema"

const useTotalPorPagar = (
    ultima_renta: Renta | null | undefined,
): number => {
    const totalOrdenPendiente =
        ultima_renta?.saldo_pendiente_ordenes &&
            ultima_renta.saldo_pendiente_ordenes > 0
            ? ultima_renta.saldo_pendiente_ordenes
            : 0

    const totalEstanciaPendiente =
        ultima_renta?.saldo_pendiente_estancia &&
            ultima_renta.saldo_pendiente_estancia > 0
            ? ultima_renta.saldo_pendiente_estancia
            : 0

    return (totalEstanciaPendiente + totalOrdenPendiente)
}

export default useTotalPorPagar
